import haileabHeadshot from '../assets/haileab-headshot.png'

export enum TestimonialSize {
  Small,
  Large,
}

type TestimonialProps = {
  size: TestimonialSize
}

/**
 * NOTE: This component gets hidden below `lg` screen sizes.
 */
export const Testimonial = ({ size }: TestimonialProps): JSX.Element => (
  <figure
    className={`relative hidden ${
      size === TestimonialSize.Large
        ? 'col-span-7 lg:block ml-8'
        : 'col-span-5 xl:block ml-4'
    }`}
  >
    <blockquote className='font-light text-3xl leading-relaxed before:content-[open-quote] before:text-brand-purple before:text-6xl before:font-bold before:absolute before:-left-9 before:-top-2 after:content-[close-quote] after:text-brand-purple after:text-6xl after:font-bold after:absolute after:ml-2 after:-mt-1'>
      Guaranteeing my income
      <br />
      without sacrificing my flexibility
      <br />
      is a no brainer.
    </blockquote>
    <div className='flex gap-1'>
      <figcaption className='mt-4'>
        <cite className='text-brand-purple not-italic font-semibold text-lg'>
          Haileab Mered
        </cite>
        <p className='text-sm font-light mt-2'>
          Uber early adopter, Belay integration tester and early adopter
        </p>
      </figcaption>
      <img className='-mt-10 max-w-sm' width='45%' src={haileabHeadshot} />
    </div>
  </figure>
)
